export const topBarHeight = 64
export const sideNavWidth = 260
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200

export const GSA_SUPPORTING_RED = '#fe0000';
export const GSA_SUPPORTING_YELLOW = '#fefd02';
export const GSA_SUPPORTING_BLUE = '#0000fe';
export const GSA_SUPPORTING_GREEN = '#03cd00';